export const calculateSipEMI = (investmentAmount, period, returnAmount) => {
  var result,
    amount = investmentAmount,
    year = period,
    returns = returnAmount;

  amount = (!isNaN(amount) && amount) || 0;
  year = (!isNaN(year) && year) || 0;
  returns = (!isNaN(returns) && returns) || 0;
  result = (amount * (returns / 100 / 12)) / (Math.pow(1 + returns / 100 / 12, year * 12) - 1);
  // result = Math.round((result && result > 1000 && Math.round(result / 1000) * 1000) || result);
  return result.toFixed(2);
};

export const lumpSumCalculation = (investmentAmount, period, returnAmount) => {
  var e = returnAmount / 100,
    t = parseFloat(period),
    c = investmentAmount || 0,
    r,
    i,
    o,
    a;
  r = c;
  i = r / Math.pow(1 + e, t);
  o = i || r;
  a = Math.round(r - Math.round(i));

  return { a, o };
};

export const amountTransform = (input, useSymbol) => {
  var ans = '',
    currencySymbol = useSymbol ? '₹' : '';
  try {
    if (input) {
      var result = input.toString().replace(/,/g, '').split('.');
      var lastThree = result[0].substring(result[0].length - 3);
      var otherNumbers = result[0].substring(0, result[0].length - 3);
      if (otherNumbers !== '') {
        lastThree = ',' + lastThree;
      }
      ans = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
      if (result.length > 1) {
        ans += '.' + result[1];
      }
      ans = (!isNaN(ans.toString().replace(/,/g, '')) && ans) || 0;
      return (currencySymbol && currencySymbol + ' ' + ans) || ans;
    }
  } catch (e) {
    console.error(e);
  }
  return ans;
};
